import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowLeft } from 'react-icons/fi';
import styles from './TermsOfUse.module.css';
import { HIDDEN_TERMS_SECTION_KEYS, TEMP_CRM_PIVOT } from '../../config/tempCrmPivot';
import SEO from '../../Components/SEO/SEO';
import { STATIC_PAGE_META } from '../../seo/pageMeta';

const SECTIONS = [
  { key: 'section1' },
  { key: 'section2' },
  { key: 'section3' },
  { key: 'section4' },
  { key: 'section5' },
  { key: 'section6' },
  { key: 'section7' },
  { key: 'section8' },
  { key: 'section9' },
  { key: 'section10' },
  { key: 'section11' },
  { key: 'section12' },
  { key: 'section13' },
  { key: 'section14' },
  { key: 'section15' },
];

function termsBodyKey(sectionKey) {
  if (!TEMP_CRM_PIVOT) return `legal.termsOfUse.${sectionKey}Body`;
  if (sectionKey === 'section3') return 'tempPivot.legal.termsSection3Body';
  if (sectionKey === 'section5') return 'tempPivot.legal.termsSection5Body';
  if (sectionKey === 'section15') return 'tempPivot.legal.termsSection15Body';
  return `legal.termsOfUse.${sectionKey}Body`;
}

const TermsOfUse = () => {
  const { t } = useTranslation();
  const visibleSections = SECTIONS.filter(
    ({ key }) => !TEMP_CRM_PIVOT || !HIDDEN_TERMS_SECTION_KEYS.has(key)
  );

  return (
    <div className={styles.page}>
      <SEO {...STATIC_PAGE_META['terms-of-use']} />
      <div className={styles.container}>
        <Link to="/" className={styles.backButton} aria-label={t('legal.back')}>
          <FiArrowLeft /> {t('legal.back')}
        </Link>
        <h1 className={styles.title}>{t('legal.termsOfUse.title')}</h1>
        <p className={styles.lastUpdated}>{t('legal.termsOfUse.lastUpdated')}</p>
        {visibleSections.map(({ key }) => (
          <section key={key} className={styles.section}>
            <h2 className={styles.sectionTitle}>{t(`legal.termsOfUse.${key}Title`)}</h2>
            <p className={styles.sectionBody}>{t(termsBodyKey(key))}</p>
          </section>
        ))}
      </div>
    </div>
  );
};

export default TermsOfUse;
